import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/5">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_bekar-360-platform/artifacts/uayxxcca_BMG%20Logo%20white%405x.png" 
              alt="BEKÂR Music Group" 
              className="h-10 w-auto mb-6"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              A full-service 360 music group empowering artists to reach their full potential.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wide">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/artists" className="text-white/60 hover:text-white text-sm transition-colors duration-300">
                  Our Artists
                </Link>
              </li>
              <li>
                <Link to="/ecosystem" className="text-white/60 hover:text-white text-sm transition-colors duration-300">
                  The Eco-System
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-white/60 hover:text-white text-sm transition-colors duration-300">
                  News & Updates
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/60 hover:text-white text-sm transition-colors duration-300">
                  Get In Touch
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wide">Services</h3>
            <ul className="space-y-3 text-sm text-white/60">
              <li>Music Production</li>
              <li>Label & Distribution</li>
              <li>Publishing & Sync</li>
              <li>Marketing & Promotion</li>
              <li>Photo & Video</li>
              <li>Management & Booking</li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-white font-semibold mb-4 tracking-wide">Connect With Us</h3>
            <div className="flex gap-3 mb-6">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-all duration-300 hover:scale-110"
              >
                <Instagram size={18} className="text-white" />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-all duration-300 hover:scale-110"
              >
                <Facebook size={18} className="text-white" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-all duration-300 hover:scale-110"
              >
                <Twitter size={18} className="text-white" />
              </a>
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-all duration-300 hover:scale-110"
              >
                <Youtube size={18} className="text-white" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-all duration-300 hover:scale-110"
              >
                <Linkedin size={18} className="text-white" />
              </a>
            </div>
            <p className="text-white/40 text-xs">
              info@bekarmusicgroup.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} BEKÂR Music Group. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-white/40">
            <a href="/privacy" className="hover:text-white transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-white transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
